import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'replaceAll',
})
export class ReplaceAllPipe implements PipeTransform {
  transform(value: string, args?: { from: string[]; to: string }): string {
    if (value) {
      args?.from.forEach((word) => {
        value = value.replace(word, args.to);
      });
    }
    return value;
  }
}
